import { RefObject, useEffect } from 'react';
import { DropTargetMonitor } from 'react-dnd';
import { useReactDndConstructs as useDragAndDropHooks } from '../../../../dnd/ReactDndContext';
import { DraggableTabProps } from '../../../TabBar/__internal__';

export function useDragHoverOnScrollButton(
  ref: RefObject<HTMLButtonElement>,
  acceptDropTypes: string[],
  callback: () => void,
  delay = 500
) {
  const { useDrop } = useDragAndDropHooks();
  const [{ isOver }, connectDropTarget] = useDrop({
    accept: acceptDropTypes,
    canDrop: () => true,
    collect: (monitor) => ({ isOver: monitor.isOver() }),
    drop: (_item: DraggableTabProps, monitor: DropTargetMonitor) => {
      if (!monitor.didDrop()) {
        return { isBaseScrollableButtons: true };
      }
    },
  });

  useEffect(() => {
    let timer: any;
    if (isOver) {
      timer = setTimeout(() => {
        callback();
      }, delay);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isOver, delay, callback]);

  connectDropTarget(ref);
}
